import { getLanguage, Language } from '../i18n';

export const formatDateLong = (date: string | Date, language?: Language) => {
  const locale = languageToLocale[language ?? getLanguage()];

  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};
const languageToLocale: Record<Language, string> = {
  nl: 'nl-NL',
  en: 'en-US',
};
